import { render } from "./DocumentDetails.vue?vue&type=template&id=43fd6e4a&scoped=true"
import script from "./DocumentDetails.vue?vue&type=script&lang=js"
export * from "./DocumentDetails.vue?vue&type=script&lang=js"

import "./DocumentDetails.vue?vue&type=style&index=0&id=43fd6e4a&scoped=true&lang=css"
import "./DocumentDetails.vue?vue&type=style&index=1&id=43fd6e4a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fd6e4a"]])

export default __exports__